import store from "@/store";

import DashboardLayout from "../components/Dashboard/Layout/DashboardLayout.vue";
import NotFoundPage from "../components/GeneralViews/NotFoundPage.vue";
import Login from "../components/Dashboard/Views/Forms/ValidationForms/LoginForm.vue";

import DashboardPage from "../components/Dashboard/Views/Pages/Dashboard.vue";
import SuperadminDashboardPage from "../components/Dashboard/Views/Pages/SuperadminDashboard.vue";

import CustomerListPage from "../components/Dashboard/Views/Pages/Customer/List.vue";
import CustomerDetailPage from "../components/Dashboard/Views/Pages/Customer/Detail.vue";
import TicketListPage from "../components/Dashboard/Views/Pages/Customer/SupportList.vue";
import TicketDetailPage from "../components/Dashboard/Views/Pages/Customer/SupportDetail.vue";
import UserReportPage from "../components/Dashboard/Views/Pages/UserReport/List.vue";

import ModeratorListPage from "../components/Dashboard/Views/Pages/Moderator/List.vue";
import ModeratorCreatePage from "../components/Dashboard/Views/Pages/Moderator/Create.vue";
import ModeratorSupportPage from "../components/Dashboard/Views/Pages/Moderator/Support.vue";
import ModeratorDetailPage from "../components/Dashboard/Views/Pages/Moderator/Detail.vue";

import BlacklistModerator from "../components/Dashboard/Views/Pages/Blacklist/Moderator.vue";

import AgencyPage from "../components/Dashboard/Views/Pages/Moderator/Agency.vue";
import ModBillingPage from "../components/Dashboard/Views/Pages/Moderator/ModBillingPage.vue";
import ModeratorNotificationPage from "../components/Dashboard/Views/Pages/Moderator/Notification.vue";

import CustomerMediaListPage from "../components/Dashboard/Views/Pages/CustomerMedia/List.vue";

import FakeListPage from "../components/Dashboard/Views/Pages/Fake/List.vue";
import FakeCreatePage from "../components/Dashboard/Views/Pages/Fake/Create.vue";
import FakeUpdatePage from "../components/Dashboard/Views/Pages/Fake/Update.vue";
import FakeDetailPage from "../components/Dashboard/Views/Pages/Fake/Detail.vue";
import FakeOnlinePage from "../components/Dashboard/Views/Pages/Fake/Online.vue";
import FakeStatisticPage from "../components/Dashboard/Views/Pages/Fake/Statistic.vue";

import AffiliatePage from "../components/Dashboard/Views/Pages/Affiliate/List.vue";
import AffiliateCreatePage from "../components/Dashboard/Views/Pages/Affiliate/Create.vue";
import AffiliateUpdatePage from "../components/Dashboard/Views/Pages/Affiliate/Update.vue";
import AffiliatePublic from "../components/Dashboard/Views/Pages/Affiliate/PublicList.vue";

import PostbackListPage from "../components/Dashboard/Views/Pages/Postback/List.vue";
import PostbackCreatePage from "../components/Dashboard/Views/Pages/Postback/Create.vue";
import PostbackUpdatePage from "../components/Dashboard/Views/Pages/Postback/Update.vue";

import TransactionPage from "../components/Dashboard/Views/Pages/Payment/Transaction.vue";
import TransactionDetailPage from "../components/Dashboard/Views/Pages/Payment/Detail.vue";
import RevenuePage from "../components/Dashboard/Views/Pages/Payment/Revenue.vue";
import GraphPage from "../components/Dashboard/Views/Pages/Payment/Graph.vue";
import PaymentSettings from "../components/Dashboard/Views/Pages/Payment/Settings.vue";

import ExportInvoicePage from "../components/Dashboard/Views/Pages/Invoice/export.vue";

import SettingsPage from "../components/Dashboard/Views/Pages/Settings.vue";

import CompanyDate from "../components/Dashboard/Views/Pages/CompanyDate/Settings.vue";

import CouponPage from "../components/Dashboard/Views/Pages/Coupon/List.vue";
import CouponCreatePage from "../components/Dashboard/Views/Pages/Coupon/Create.vue";
import CouponUpdatePage from "../components/Dashboard/Views/Pages/Coupon/Update.vue";

import GiftPage from "../components/Dashboard/Views/Pages/Gift/List.vue";
import GiftCreatePage from "../components/Dashboard/Views/Pages/Gift/Create.vue";
import GiftUpdatePage from "../components/Dashboard/Views/Pages/Gift/Update.vue";

import GiftCategoryPage from "../components/Dashboard/Views/Pages/GiftCategory/List.vue";
import GiftCategoryCreatePage from "../components/Dashboard/Views/Pages/GiftCategory/Create.vue";
import GiftCategoryUpdatePage from "../components/Dashboard/Views/Pages/GiftCategory/Update.vue";

import NewsPage from "../components/Dashboard/Views/Pages/News/List.vue";
import NewsCreatePage from "../components/Dashboard/Views/Pages/News/Create.vue";
import NewsUpdatePage from "../components/Dashboard/Views/Pages/News/Update.vue";

import AutomaticMessageListPage from "../components/Dashboard/Views/Pages/AutomaticMessage/List.vue";
import AutomaticMessageRulesPage from "../components/Dashboard/Views/Pages/AutomaticMessage/Rules.vue";
import AutomaticMessageUpdatePage from "../components/Dashboard/Views/Pages/AutomaticMessage/Update.vue";

import AsaPage from "../components/Dashboard/Views/Pages/Asa/List.vue";
import AsaCreatePage from "../components/Dashboard/Views/Pages/Asa/Create.vue";
import AsaUpdatePage from "../components/Dashboard/Views/Pages/Asa/Update.vue";

import DialogListPage from "../components/Dashboard/Views/Pages/Dialog/List.vue";
import DialogDetailPage from "../components/Dashboard/Views/Pages/Dialog/Detail.vue";

import PriceLevelPage from "../components/Dashboard/Views/Pages/PriceLevel/List.vue";
import PriceLevelCreatePage from "../components/Dashboard/Views/Pages/PriceLevel/Create.vue";
import PriceLevelUpdatePage from "../components/Dashboard/Views/Pages/PriceLevel/Update.vue";

import CircularMailListPage from "../components/Dashboard/Views/Pages/CircularMail/List.vue";
import CircularMailCreatePage from "../components/Dashboard/Views/Pages/CircularMail/Create.vue";
import CircularMailUpdatePage from "../components/Dashboard/Views/Pages/CircularMail/Update.vue";
import CircularMailReceiverPage from "../components/Dashboard/Views/Pages/CircularMail/Receiver.vue";

import SupportDetailPage from "../components/Dashboard/Views/Pages/Support/Detail.vue";

import ModerationDetailPage from "../components/Dashboard/Views/Pages/Moderation/Detail.vue";

import SupportTemplatePage from "../components/Dashboard/Views/Pages/SupportTemplate/Page.vue";

import StatisticEmailQueuePage from "../components/Dashboard/Views/Pages/Statistic/EmailQueue.vue";
import StatisticUserSessionPage from "../components/Dashboard/Views/Pages/Statistic/UserSession.vue";
import StatisticUserInfoPage from "../components/Dashboard/Views/Pages/Statistic/UserInfo.vue";
import StatisticBouncedEmailPage from "../components/Dashboard/Views/Pages/Statistic/BouncedEmail.vue";
import StatisticMessageAnalysePage from "../components/Dashboard/Views/Pages/Statistic/MessageAnalyse.vue";
import StatisticGraphPage from "../components/Dashboard/Views/Pages/Statistic/Graph.vue";
import StatisticEmailLogPage from "../components/Dashboard/Views/Pages/Statistic/EmailLog.vue";

import MailConnectionSettingsPage from "../components/Dashboard/Views/Pages/MailConnectionSetting/MailConnectionSettings.vue";

import CircularMailSettings from "../components/Dashboard/Views/Pages/CircularMailSettings/Settings.vue";

import MailSubjects from "../components/Dashboard/Views/Pages/MailSubjects/List.vue";

import ScriptInjection from "../components/Dashboard/Views/Pages/ScriptInjection.vue";

import UnsubscribeTokenSetting from "../components/Dashboard/Views/Pages/UnsubscribeTokenSettings.vue";

import ExternRegistrationPage from "../components/Dashboard/Views/Pages/ExternRegistration/ExternRegistration.vue";

import SystemUserList from "../components/Dashboard/Views/Pages/SystemUser/List.vue";
import SystemUserCreate from "../components/Dashboard/Views/Pages/SystemUser/Create.vue";
import SystemUserUpdate from "../components/Dashboard/Views/Pages/SystemUser/Update.vue";
import SystemUserDetail from "../components/Dashboard/Views/Pages/SystemUser/Detail.vue";

import EmailVerificationResend from "../components/Dashboard/Views/Pages/Mail/Resend.vue";

import FooterPages from "../components/Dashboard/Views/Pages/FooterPages/Update.vue";
import FaqArticles from "../components/Dashboard/Views/Pages/FooterPages/Faq.vue";

import CacheUpdate from "../components/Dashboard/Views/Pages/Cache/Update.vue";

import Backups from "../components/Dashboard/Views/Pages/Backups/List.vue";

import LogoutMember from "../components/Dashboard/Views/Pages/LogoutMember/List.vue";

import SystemSettings from "../components/Dashboard/Views/Pages/SystemSettings.vue";

import GitVersions from "../components/Dashboard/Views/Pages/GitVersions/List.vue";

import Logging from "../components/Dashboard/Views/Pages/Logging/Update.vue";

import ImageSettings from "../components/Dashboard/Views/Pages/Image/Settings.vue";

import BlacklistUsername from "../components/Dashboard/Views/Pages/Blacklist/Username.vue";

import Layout from "../components/Dashboard/Views/Pages/Layout/Update.vue";

import SuperadminMessengers from "../components/Dashboard/Views/Pages/Messengers/Superadmin.vue";
import AdminMessengers from "../components/Dashboard/Views/Pages/Messengers/Admin.vue";

import MailSettings from "../components/Dashboard/Views/Pages/MailSettings/Setting.vue";

import FriendshipPrice from "../components/Dashboard/Views/Pages/FriendshipPrice/Setting.vue";

import SuperadminFakeSettings from "../components/Dashboard/Views/Pages/Fake/Superadmin.vue";

import NewDialogSettings from "../components/Dashboard/Views/Pages/NewDialogSettings/Settings.vue";

const routes = [
  {
    path: "/affiliate/public/:slug",
    component: AffiliatePublic
  },
  {
    path: "/",
    component: DashboardLayout,
    redirect: () => {
      return store.getters["user/meHasPermissionTo"]("access_fake_profile_area")
        ? "/fake/list"
        : store.getters["user/meHasPermissionTo"]("access_circular_mail_area")
        ? "rundmail/liste"
        : "menu";
    },
    children: [
      {
        path: "/login",
        component: Login
      },
      {
        path: "/menu",
        component: DashboardPage,
        roles: ["admin"]
      },
      {
        path: "/superadmin/menu",
        component: SuperadminDashboardPage,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/mitglieder/list",
        component: CustomerListPage,
        roles: ["admin"]
      },
      {
        path: "/mitglieder/pruefung",
        component: CustomerMediaListPage,
        roles: ["admin"]
      },
      {
        path: "/mitglieder/support",
        component: TicketListPage,
        roles: ["admin"]
      },
      {
        path: "/mitglieder/support/:id",
        component: TicketDetailPage,
        roles: ["admin"]
      },
      {
        path: "/mitglieder/kartei/:id",
        component: CustomerDetailPage,
        roles: ["admin", "profile_builder"]
      },
      {
        path: "/mitglieder/gemeldet",
        component: UserReportPage,
        roles: ["admin"]
      },
      {
        path: "/fake/list",
        component: FakeListPage,
        roles: ["admin", "profile_builder"]
      },
      {
        path: "/fake/erstellen",
        component: FakeCreatePage,
        roles: ["admin", "profile_builder"]
      },
      {
        path: "/fake/online",
        component: FakeOnlinePage,
        roles: ["admin"]
      },
      {
        path: "/fake/:id",
        component: FakeUpdatePage,
        roles: ["admin", "profile_builder"]
      },
      {
        path: "/fake/kartei/:id",
        component: FakeDetailPage,
        roles: ["admin", "profile_builder"]
      },
      {
        path: "/moderator/list",
        component: ModeratorListPage,
        roles: ["admin"]
      },
      {
        path: "/moderator/erstellen",
        component: ModeratorCreatePage,
        roles: ["admin"]
      },
      {
        path: "/moderator/detail/:id",
        component: ModeratorDetailPage,
        roles: ["admin"]
      },
      {
        path: "/moderator/billing",
        component: ModBillingPage,
        roles: ["admin"]
      },
      {
        path: "/moderator/meldungen",
        component: ModeratorNotificationPage,
        roles: ["admin"]
      },
      {
        path: "/moderator/support",
        component: ModeratorSupportPage,
        roles: ["admin"]
      },
      {
        path: "/blacklist/moderator",
        component: BlacklistModerator,
        roles: ["admin"]
      },
      {
        path: "/moderation",
        component: ModerationDetailPage,
        roles: ["admin"]
      },
      {
        path: "/agenturen",
        component: AgencyPage,
        roles: ["admin"]
      },
      {
        path: "/zahlungen/vorgaenge",
        component: TransactionPage,
        roles: ["admin"]
      },
      {
        path: "/zahlungen/umsaetze",
        component: RevenuePage,
        roles: ["admin"]
      },
      {
        path: "/zahlungen/graph",
        component: GraphPage,
        roles: ["admin"]
      },
      {
        path: "/zahlungen/detail/:id",
        component: TransactionDetailPage,
        roles: ["admin"]
      },
      {
        path: "/export-invoice",
        component: ExportInvoicePage,
        roles: ["admin"]
      },
      {
        path: "/rundmail/liste",
        component: CircularMailListPage,
        roles: ["admin", "circular_mail_writer"]
      },
      {
        path: "/rundmail/empfänger/:id",
        component: CircularMailReceiverPage,
        roles: ["admin", "circular_mail_writer"]
      },
      {
        path: "/rundmail/erstellen/:id?",
        component: CircularMailCreatePage,
        roles: ["admin", "circular_mail_writer"]
      },
      {
        path: "/rundmail/:id",
        component: CircularMailUpdatePage,
        roles: ["admin", "circular_mail_writer"]
      },
      {
        path: "/rundmail/unbeachteteNeuAnschreiben/:id?",
        component: CircularMailCreatePage,
        roles: ["admin", "circular_mail_writer"]
      },
      {
        path: "/automatische-nachrichten/liste",
        component: AutomaticMessageListPage,
        roles: ["admin"]
      },
      {
        path: "/automatische-nachrichten/erstellen",
        component: AutomaticMessageRulesPage,
        roles: ["admin"]
      },
      {
        path: "/automatische-nachrichten/:id",
        component: AutomaticMessageUpdatePage,
        roles: ["admin"]
      },
      {
        path: "/dialogkontrolle",
        component: DialogListPage,
        roles: ["admin"]
      },
      {
        path: "/dialogkontrolle/:id",
        component: DialogDetailPage,
        roles: ["admin"]
      },
      {
        path: "/werbung/liste",
        component: AffiliatePage,
        roles: ["admin"]
      },
      {
        path: "/werbung/erstellen",
        component: AffiliateCreatePage,
        roles: ["admin"]
      },
      {
        path: "/werbung/:id",
        component: AffiliateUpdatePage,
        roles: ["admin"]
      },
      {
        path: "/gutschein/liste",
        component: CouponPage,
        roles: ["admin"]
      },
      {
        path: "/gutschein/erstellen",
        component: CouponCreatePage,
        roles: ["admin"]
      },
      {
        path: "/gutschein/:id",
        component: CouponUpdatePage,
        roles: ["admin"]
      },
      {
        path: "/geschenk/liste",
        component: GiftPage,
        roles: ["admin"]
      },
      {
        path: "/geschenk/erstellen",
        component: GiftCreatePage,
        roles: ["admin"]
      },
      {
        path: "/geschenk/:id",
        component: GiftUpdatePage,
        roles: ["admin"]
      },
      {
        path: "/geschenkkategorie/liste",
        component: GiftCategoryPage,
        roles: ["admin"]
      },
      {
        path: "/geschenkkategorie/erstellen",
        component: GiftCategoryCreatePage,
        roles: ["admin"]
      },
      {
        path: "/geschenkkategorie/:id",
        component: GiftCategoryUpdatePage,
        roles: ["admin"]
      },
      {
        path: "/news/liste",
        component: NewsPage,
        roles: ["admin"]
      },
      {
        path: "/news/erstellen",
        component: NewsCreatePage,
        roles: ["admin"]
      },
      {
        path: "/news/:id",
        component: NewsUpdatePage,
        roles: ["admin"]
      },
      {
        path: "/asa/liste",
        component: AsaPage,
        roles: ["admin"]
      },
      {
        path: "/asa/erstellen",
        component: AsaCreatePage,
        roles: ["admin"]
      },
      {
        path: "/asa/:id",
        component: AsaUpdatePage,
        roles: ["admin"]
      },
      {
        path: "/einstellungen",
        component: SettingsPage,
        roles: ["admin"]
      },
      {
        path: "/company-date",
        component: CompanyDate,
        roles: ["admin"]
      },
      {
        path: "/preisstufe/liste",
        component: PriceLevelPage,
        roles: ["admin"]
      },
      {
        path: "/preisstufe/erstellen",
        component: PriceLevelCreatePage,
        roles: ["admin"]
      },
      {
        path: "/preisstufe/:id",
        component: PriceLevelUpdatePage,
        roles: ["admin"]
      },
      {
        path: "/support/profile/:id",
        component: SupportDetailPage,
        roles: ["admin"]
      },
      {
        path: "/support-vorlagen/erstellen",
        component: SupportTemplatePage,
        roles: ["admin"]
      },
      {
        path: "/neueDialogeEinstellung",
        component: NewDialogSettings,
        roles: ["admin"]
      },
      {
        path: "/statistiken/email/warteschlange",
        component: StatisticEmailQueuePage,
        roles: ["admin"]
      },
      {
        path: "/statistiken/user-sessions",
        component: StatisticUserSessionPage,
        roles: ["admin"]
      },
      {
        path: "/statistiken/email-blockierungen",
        component: StatisticBouncedEmailPage,
        roles: ["admin"]
      },
      {
        path: "/statistiken/emails",
        component: StatisticEmailLogPage,
        roles: ["admin"]
      },
      {
        path: "/statistiken/nachrichtenanalyse",
        component: StatisticMessageAnalysePage,
        roles: ["admin"]
      },
      {
        path: "/statistiken/graph",
        component: StatisticGraphPage,
        roles: ["admin"]
      },
      {
        path: "/statistiken/fakes",
        component: FakeStatisticPage,
        roles: ["admin"]
      },
      {
        path: "/mail-connection-setting/uebersicht",
        component: MailConnectionSettingsPage,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/mail-subjects/list",
        component: MailSubjects
      },
      {
        path: "/mail-settings",
        component: MailSettings
      },
      {
        path: "/circular-mails-setting",
        component: CircularMailSettings
      },
      {
        path: "/script-injection",
        component: ScriptInjection,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/abmeldelink-email",
        component: UnsubscribeTokenSetting,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/werbungsverfolgung/liste",
        component: PostbackListPage,
        roles: ["admin"]
      },
      {
        path: "/werbungsverfolgung/erstellen",
        component: PostbackCreatePage,
        roles: ["admin"]
      },
      {
        path: "/werbungsverfolgung/:id",
        component: PostbackUpdatePage,
        roles: ["admin"]
      },
      {
        path: "/messengers",
        component: AdminMessengers,
        roles: ["admin"]
      },
      {
        path: "/externe-registrierung/uebersicht",
        component: ExternRegistrationPage,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/statistiken/benutzerinformationen",
        component: StatisticUserInfoPage,
        roles: ["admin"]
      },
      {
        path: "/systemuser/list",
        component: SystemUserList,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/systemuser/erstellen",
        component: SystemUserCreate,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/systemuser/kartei/:id",
        component: SystemUserDetail,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/systemuser/:id",
        component: SystemUserUpdate,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/paymentsettings",
        component: PaymentSettings,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/email-verification-resend",
        component: EmailVerificationResend,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/footer-pages",
        component: FooterPages,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/faq-articles",
        component: FaqArticles,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/cache/update",
        component: CacheUpdate,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/logging-setting",
        component: Logging,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/backups",
        component: Backups,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/logout-member",
        component: LogoutMember,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/superadmin/system-settings",
        component: SystemSettings,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/git-versions",
        component: GitVersions,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/image-settings",
        component: ImageSettings,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/blacklist/username",
        component: BlacklistUsername,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/Layout",
        component: Layout,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/superadmin/messengers",
        component: SuperadminMessengers,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/friendship-price",
        component: FriendshipPrice,
        permissions: ["access_super_admin_area"]
      },
      {
        path: "/superadmin/fake",
        component: SuperadminFakeSettings,
        permissions: ["access_super_admin_area"]
      }
    ]
  },
  { path: "*", component: NotFoundPage }
];

export default routes;
